<template>
  <div class="card mb-3 border border-1 border-secondary shadow-sm">
    <div v-if="title.length != 0" class="card-header text-start">
      <h2 class="fs-4 fw-bold my-auto">{{ title }}</h2>
    </div>
    <div class="card-body">
      <div
        v-if="!summary == ''"
        class="alert alert-primary border-secondary text-start text-dark mb-0"
      >
        {{ summary }}
      </div>
      <div v-if="hasSlot && summary" class="mb-3"></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "DynamicCard",
  props: {
    title: {
      type: String,
      default: ""
    },
    summary: String
  },
  computed: {
    hasSlot() {
      return this.$slots.default !== undefined;
    }
  }
};
</script>
